import instance from '@/services/repository';

const resource = '/creditNotes';

export default {
    lookup(options: any, contactId?: string, projectId?: string) {
        /*const formData = new FormData();

        for ( const key in options ) {
            if (options.hasOwnProperty(key)) {
                formData.append(key, JSON.stringify(options[key]));
            }
        }*/

        if (!contactId) {
            contactId = '';
        }
        if (!projectId) {
            projectId = '';
        }

        options.requireTotalCount = true;
        options.stringToLower = true;


        return instance.post(`${resource}/lookup`, {
            options,
            contactId,
            projectId,
        });
        /*return instance
            .post(`${resource}/lookup${query}`,
                formData,
                {
                    headers: {'Content-Type': 'multipart/form-data' },
                });*/
    },
    getSingle(id: string) {
        return instance.get<any>(`${resource}/${id}`);
    },
    create(payload: ICreateCreditNoteCommand) {
        return instance.post<string>(`${resource}`, payload);
    },
    update(payload: any) {
        return instance.put(`${resource}/${payload.id}`, payload);
    },
    delete(id: string) {
        return instance.delete(`${resource}/${id}`);
    },
    download(id: string) {
        return instance
            .get<Blob>(`${resource}/${id}/document`, { responseType: 'blob' });
    },
    getStatusOptions() {
        return [
            {value: 1, text: 'Open'},
            {value: 2, text: 'Verstuurd'},
            {value: 4, text: 'Betaald'},
        ];
    },
    mail(payload: any) {
        return instance.post(`${resource}/Mail`, payload);
    },
};
